



























import { Component, Vue } from 'vue-property-decorator';
import eventBus from '@/common/bus';
import StoreVuexModule from '@/stores/StoreVuexModule';
import { getModule } from 'vuex-module-decorators';

@Component({
  name: 'App',
})
export default class App extends Vue {
  private errorSnackbar: boolean = false;
  private errorSnackbarText: string = '';
  private currentWindowHeight: number = 0;
  private store = getModule(StoreVuexModule, this.$store);
  private debounceTimeout: NodeJS.Timeout | null = null;

  public mounted() {
    eventBus.$on('errorHandler', (errorMsg: any, logError: boolean = false) => {
      if (logError) {
        this.errorSnackbarText = errorMsg;
        this.errorSnackbar = true;
      }
    });

    requestAnimationFrame(this.maintainWindowHeight);
  }

  public maintainWindowHeight() {
    const windowHeight = this.$el.clientHeight;
    if (windowHeight !== this.currentWindowHeight) {
      // send message
      this.debounce(() => {
        if (this.store.parentOrigin) {
          window.parent.postMessage(
            { type: 'resize window', height: windowHeight },
            this.store.parentOrigin,
          );
          this.currentWindowHeight = windowHeight;
        }
      });
    }
    requestAnimationFrame(this.maintainWindowHeight);
  }

  private clearErrorSnackbar(): void {
    this.errorSnackbar = false;
    this.errorSnackbarText = '';
  }

  private debounce(f: () => void): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(f, 100);
  }
}
